"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EnvConstans = require("./EnvConstans");
// DEV SETTINGS
var _default = exports.default = {
  dev: _EnvConstans.EndpointEnv.dev,
  staging: _EnvConstans.EndpointEnv.staging,
  production: _EnvConstans.EndpointEnv.production
};